import React from "react";
import { useAccordion } from "./hooks/useAccordion";
import { ReactComponent as IconArrowDown } from "../../build/images/AccordionAssets/arrow-down.svg";
import { ReactComponent as IconArrowUp } from "../../build/images/AccordionAssets/arrow-up.svg";

import "./accordion.styles.css";

const Accordion = ({ icon = <></>, title, children }) => {
  const { isOpen, handleToggleOpen } = useAccordion();
  return (
    <div className={`accordion-new ${isOpen ? "open" : ""}`}>
      <div onClick={handleToggleOpen} className="accordion-new__header">
        <div className="accordion-new__header__title-container">
          {icon}
          <h2>{title}</h2>
        </div>
        <div>{isOpen ? <IconArrowUp /> : <IconArrowDown />}</div>
      </div>
      {isOpen && <main>{children}</main>}
    </div>
  );
};

export default Accordion;
